import { render, staticRenderFns } from "./HomeRecordsComponent.vue?vue&type=template&id=4e0ddb25&scoped=true&"
import script from "./HomeRecordsComponent.vue?vue&type=script&lang=js&"
export * from "./HomeRecordsComponent.vue?vue&type=script&lang=js&"
import style0 from "./HomeRecordsComponent.vue?vue&type=style&index=0&id=4e0ddb25&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0ddb25",
  null
  
)

export default component.exports